var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('global-header-search-block', {
    attrs: {
      "config": _vm.environment.toUpperCase()
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };